import { render } from "./ChatComponent.vue?vue&type=template&id=6183f9ea&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"

import "./ChatComponent.vue?vue&type=style&index=0&id=6183f9ea&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6183f9ea"]])

export default __exports__